
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/inner-engineering-pc",
      function () {
        return require("private-next-pages/[region]/[language]/inner-engineering-pc/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/inner-engineering-pc"])
      });
    }
  